import Box from "@components/Box"
import { Modal } from '@components/Modal'
import Image from "@components/Image"
import { Link, Nav } from "@components/RichTextAndTypography"
import { zIndices } from "@themes/index"
import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import * as React from "react"
import { StyledAnchor, StyledHeader } from "./styles"
import FormEmailCapture from "@components/FormEmailCapture"

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: {eq: "header/header-logo.png"}) {
        childImageSharp {
          gatsbyImageData(
            width: 203
            placeholder: TRACED_SVG
          )
        }
      }
    }
  `)

  const modalContent = () => (
    <FormEmailCapture />
  )

  return (
    <StyledHeader
      background='rgba(37, 37, 37, 0.85)'
      width="100%"
      position='absolute'
      zIndex={zIndices.navigation}
    >
      <Nav
        px={['32px', null, null, '48px', "64px"]}
        py={["24px", null, '32px', null, '16px']}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Link to="/">
          <Image
            image={getImage(data?.logo)}
            alt="Hell is Others logo"
            maxWidth={["117px", null, null, '140px', "initial"]}
          />
        </Link>
        <Box
          display="flex"
          flexDirection={["column", null, 'row']}
          alignItems={["flex-end", null, 'initial']}
          gridRowGap="8px"
          gridColumnGap={[null, null, "32px"]}
          fontSize={[null, null, null, '20px', '24px']}
          fontWeight="300"
          color="tanDark"
        >
          <Modal contentFunction={modalContent}>
            SIGN UP FOR NEWS
          </Modal>
          <StyledAnchor href="https://youtu.be/zfPoRWevu0I">
            WATCH TRAILER
          </StyledAnchor>
          <StyledAnchor href="https://gsght.com/c/jckrpr">
            BUY NOW
          </StyledAnchor>
        </Box>
      </Nav>
    </StyledHeader>
  )
}

export default Header
